import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PermissionService, UserService, SnackbarService } from '@app/services';
import { Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';

@Injectable()
export class EditionsGuard implements CanActivate {

  constructor(
    private userService: UserService,
    private permissionService: PermissionService,
    private snackbarService: SnackbarService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const accountType = this.userService.currentUser?.accountType;
    const perm = accountType === 'family' ? 'editions_access' : 'assmat_editions_access';

    return this.permissionService.permission$.pipe(
      map(permissions => permissions && permissions[perm]),
      tap(hasAccess => {
        if (!hasAccess) {
          this.snackbarService.open({
            message: 'Cette fonctionnalité n\'est pas activée',
            type: 'error',
            duration: 5000
          });
        }
      })
    );
  }
}
